module.exports = __webpack_public_path__ + "img/handshake-icon.f0c7ee8a.png";